<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>
    <div class="mypage mypage_change mypage_change-pass">
      <div class="wrap mypage_wrap">
        <div class="login_id-pass">
          <div class="login_input-box two-fac new-pass">
            <p class="login_two-fac_title">
              パスワードを変更するために、<br />現在のパスワードを入力してください
            </p>
            <van-form style="width: 100%; max-width: 500px" ref="form">
              <p class="login_cont-name">現在のパスワード</p>
              <div class="login_pass-box">
                <input
                  class="password"
                  name="password"
                  required
                  v-model="formData.password"
                  :type="pwdFlag ? 'password' : 'text'"
                />
                <button class="btn_passview">
                  <img
                    src="@/assets/img/login/pass.png"
                    :class="[this.pwdFlag ? '' : 'img-opacity']"
                    @click="changePwd"
                    alt="非表示"
                  />
                </button>
              </div>
            </van-form>
            <p class="login_pass-lose">
              パスワードを忘れた方は<a href="javascript:;" @click="goLost"
                >こちら</a
              >
            </p>
          </div>
          <van-button
            :disabled="!this.formData.password"
            block
            :color="!this.formData.password ? '#AACBE7' : '#48b2fb'"
            type="primary"
            native-type="submit"
            @click="handleSure"
            id="mypage_btn_verify"
            >次へ</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VerifyUserPwd, SendVerifyCode } from "@/services/user";
import { Toast } from "vant";
import "vant/es/toast/style";
import Janus from "@/assets/js/janus";
import Header from "@/components/Header.vue";
export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)),
      formData: {},
      pwdFlag: true,
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.formData.id = this.user.id;
  },
  methods: {
    onClickLeft() {
      history.back();
    },
    handleSure() {
      this.$refs.form
        .validate()
        .then(() => {
          const detail = this.formData;
          VerifyUserPwd(detail).then((res) => {
            if (res.data.code >= 0) {
              if (Janus) {
                Janus.videoPageDestory();
              }
              this.$router.push("/userPasswordUpdate");
            } else {
              Toast.fail("元のパスワードが正しくありません。");
            }
          });
        })
        .catch(() => {});
    },
    changePwd() {
      this.pwdFlag = !this.pwdFlag;
    },
    goLost() {
      SendVerifyCode().then((res) => {
        if (res.data.code >= 0) {
          this.$router.push("/userLostPass");
        } else {
          Toast.fail("管理者に連絡してください。");
        }
      });
    },
  },
};
</script>

<style scoped>
   
   
  
#mypage_btn_verify {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
#mypage_btn_verify.possible {
  background: #3b82c4;
  pointer-events: auto;
}
.img-opacity {
  opacity: 0.4;
}
</style>
